import { NotificationSettingsData } from "src/shared/types/src";
import { getAxiosInstance } from "../api"

export const fetchNotificationsData = async (page: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/user/notification/list`, { params: { useAccessToken: true, page: page } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response.data;
    }
    return null;
  })
}

export const fetchNotificationUnReadCountData = async (): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/user/notification/count`, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response.data;
    }
    return null;
  })
}

export const markAsRead = async (notificationId: number): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.patch(`/user/notification/${notificationId}/read`, {}, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response;
    }
    return null;
  })
}

export const markAllAsRead = async (): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.patch(`/user/notification/mark-all-read`, {}, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response;
    }
    return null;
  })
}

export const clearAll = async (): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.delete(`/user/notification/clear-all`, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response;
    }
    return null;
  })
}

export const fetchNotificationSettingsDetails = async (): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.get(`/user/notification-details`, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response.data;
    }
    return null;
  })
}

export const updateNotificationSettings = async (requestPayload: NotificationSettingsData): Promise<any> => {
  const { retryAxios } = getAxiosInstance();
  return retryAxios.patch(`/user/notification/settings`, requestPayload, { params: { useAccessToken: true } }).then((res) => {
    const response = res.data;
    if (response && response.status === 'success') {
      return response;
    }
    return null;
  })
}